import React, { FC, useContext, useEffect } from 'react';

import { ConditionalRendering } from '@components/common/conditional-rendering';
import ErrorMessage from '@components/common/form/errorMessage';
import DatePicker from '@lib/inputs/react-datepicker';
import { DATE_FORMAT, formatDateToMMDDYYYY } from '@utils/dates/dateMethods';
import { changeFieldValue } from '../common/enrollmentUtils';
import { AddOrChangeTxnFormContext } from '../context/AddOrChangeTxnProvider';
import { StyledField } from '../styles/EnrollmentSharedStyled';

const EnrollmentLastPremPaidThroughDate: FC = () => {
    const {
        watch,
        formState: { errors },
        setValue,
        clearErrors,
        setError,
    } = useContext(AddOrChangeTxnFormContext);
    const values = watch();

    useEffect(() => {
        console.log({ errors, values });
    }, [values.enrollmentLastPremPaidThroughDateUI]);

    const onChangePremiumPaidDate = (field, value) => {
        var lastPremDate = new Date(value);

        changeFieldValue(setValue, field, formatDateToMMDDYYYY(value));
    };

    return (
        <ConditionalRendering isTrue={values.isTermReasonNonPayment}>
            <StyledField>
                <DatePicker
                    labelText="member.enrollment_list.premiumhistory.premiumPaidDate"
                    wrapperClasses={['date-picker']}
                    isRequired
                    id="enrollmentLastPremPaidThroughDateUI"
                    type="text"
                    pattern={DATE_FORMAT}
                    value={
                        values?.enrollmentLastPremPaidThroughDateUI
                            ? new Date(values.enrollmentLastPremPaidThroughDateUI)
                            : ''
                    }
                    withMask
                    onDateChange={value => onChangePremiumPaidDate('enrollmentLastPremPaidThroughDateUI', value)}
                />
                <ConditionalRendering isTrue={errors.enrollmentLastPremPaidThroughDateUI}>
                    <ErrorMessage
                        isVisible={errors.enrollmentLastPremPaidThroughDateUI}
                        messageText={errors?.enrollmentLastPremPaidThroughDateUI?.message}
                    />
                </ConditionalRendering>
            </StyledField>
        </ConditionalRendering>
    );
};

export default EnrollmentLastPremPaidThroughDate;
